export const VERSION = '3.0.0';

